<ion-toolbar color="light">
  <ion-button fill="clear" slot="start">
    <ion-title>
      {{ 'moveTest.title' | translate }}
    </ion-title>
  </ion-button>
  <ion-button fill="clear" (click)="cancel()" slot="end" [attr.aria-label]="'ariaLabel.closeButton' | translate">
    <ion-icon icon="close"></ion-icon>
  </ion-button>
</ion-toolbar>

<ion-content>
  <ion-list>
    <ion-item>
      <ion-select
        class="ion-padding"
        [placeholder]="'moveTest.selectTest' | translate"
        [attr.aria-label]="'moveTest.selectTest' | translate"
        [value]="selectedTest()"
        (ionChange)="onTestChange($event)"
        interface="popover"
        [disabled]="movePossibilities.length <= 1"
      >
        @for (test of movePossibilities; track test.testCode) {
          <ion-select-option [value]="test">
            {{ test.testDescription }}
          </ion-select-option>
        }
      </ion-select>
    </ion-item>
  </ion-list>

  @if (selectedTest()) {
    <div class="pa-plan-element">
      <pa-period-selection-grid
        [years]="gridYears()"
        [periods]="gridPeriods()"
        [availableSlots]="gridAvailableSlots()"
        [showTimeslots]="false"
        [selectable]="true"
        (selectedPeriod)="onGridSelectedPeriod($event)"
      />
    </div>
  }
</ion-content>
